import React, { ReactNode } from "react";

type Props = {
  titleColor: string;
  titleText: string;
  titleIcon: string;
  children: ReactNode;
};

const SidebarListWrap: React.FC<Props> = (props) => {
  const [open, setOpen] = React.useState(false);
  const stateToggle = () => {
    setOpen(!open);
  };
  return (
    <div>
      <div
        onClick={stateToggle}
        onKeyDown={stateToggle}
        role="button"
        tabIndex={0}
        className={`group peer relative ${open ? "open" : ""} ${
          props.titleColor
        }`}
      >
        <h3
          className={`group-[.primary]:text-primary group-[.secondary]:text-secondary group-[&.tertiary]:text-tertiary`}
        >
          <span className="flex items-center">
            <span className="flex-shrink-0 flex items-center justify-center aspect-square w-11 mr-2 rounded-full bg-default group-[.primary]:bg-primary group-[.secondary]:bg-secondary group-[.tertiary]:bg-tertiary">
              <svg className="block w-6 h-6 fill-white">
                <use
                  xlinkHref={`/symbol-defs.svg#icon-${props.titleIcon}`}
                ></use>
              </svg>
            </span>
            <span className="flex-1 text-sm font-black">
              <strong className="text-xl font-black">{props.titleText}</strong>
              を選択
            </span>
          </span>
        </h3>
        <span className="absolute right-4 top-[50%] translate-y-[-50%] inline-block group-[.primary]:fill-primary group-[.secondary]:fill-secondary group-[.tertiary]:fill-tertiary">
          <svg className="block group-[.open]:hidden w-5 h-5">
            <use xlinkHref="/symbol-defs.svg#icon-plus"></use>
          </svg>
          <svg className="hidden group-[.open]:block w-5 h-5">
            <use xlinkHref="/symbol-defs.svg#icon-minus"></use>
          </svg>
        </span>
      </div>
      <div className="grid grid-rows-[0fr] transition-[grid-template-rows] duration-500 peer-[.open]:grid-rows-[1fr] peer-[.primary]:[&_h4]:bg-[linear-gradient(to_right,#F08300_2px,transparent_2px)] peer-[.secondary]:[&_h4]:bg-[linear-gradient(to_right,#E95400_2px,transparent_2px)] peer-[.tertiary]:[&_h4]:bg-[linear-gradient(to_right,#ECAA00_2px,transparent_2px)]">
        <div className="overflow-hidden">{props.children}</div>
      </div>
    </div>
  );
};

export default SidebarListWrap;
